import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import SydLabel, { hookFormErrorAdapter } from '../../../../commonDesign/SydLabel'
import SydSelect from '../../../../commonDesign/SydSelect'
import { buildValidationRules } from '../utils/fieldUtils'

function SelectFieldEditor ({ field, control, form }) {
  const rules = buildValidationRules(field)
  const isRequired = field.validations?.required || field.required

  // Convert editorOptions to SydSelect format
  const options = (field.editorOptions || []).map(option => ({
    value: option.value,
    label: option.label || option.value,
    description: option.description
  }))

  return (
    <Controller
      name={field.id}
      control={control}
      rules={rules}
      render={({ field: hookField, fieldState }) => (
        <SydLabel
          label={field.label}
          required={isRequired}
          error={hookFormErrorAdapter(form, fieldState)}
          description={field.description}
        >
          <SydSelect
            {...hookField}
            minWidth='0'
            options={options}
            placeholder={`Select ${field.label}`}
            multiple={field.multiple || false}
          />
        </SydLabel>
      )}
    />
  )
}

SelectFieldEditor.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.string,
    required: PropTypes.bool,
    multiple: PropTypes.bool,
    validations: PropTypes.object,
    validationRules: PropTypes.object,
    editorOptions: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string,
      description: PropTypes.string
    }))
  }).isRequired,
  control: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired
}

export default SelectFieldEditor
